import { createGlobalStyle } from "styled-components";

export const GlobalOverlaysStyled = createGlobalStyle`
    .popover {
        background-color: var(--app-bg-color);
        border: none;
        max-width: none;
    }

    .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .bs-popover-top > .popover-arrow::after {
        border-top-color: var(--app-bg-color);
        bottom: 2px;
    }

    .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .bs-popover-bottom > .popover-arrow::after {
        border-bottom-color: var(--app-bg-color);
        top: 2px;
    }

    .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .bs-popover-start > .popover-arrow::after {
        border-left-color: var(--app-bg-color);
    }

    .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .bs-popover-end > .popover-arrow::after {
        border-right-color: var(--app-bg-color);
    }

    .offcanvas.show {
        //z-index: 9999;
    }

    .offcanvas {
        background-color: #000;
        overflow-y: auto;

        &.offcanvas-end {
            border-left: none;
        }

        .dropdown-menu {
            width: 100%;
            top: 3rem;
        }
    }

    .offcanvas-end {
        padding: 0;
    }

    .offcanvas-bottom {
        height: unset;
        border-radius: 16px 16px 0px 0px;
        padding: 16px;
    }

    .offcanvas-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        padding: 0 16px;
    }

    .offcanvas + .offcanvas-backdrop {
        z-index: 1050;
    }

    .offcanvas + .offcanvas-backdrop + .offcanvas {
        z-index: 1060;
    }

    .offcanvas-backdrop {
        &.z-index-1100 {
            z-index: 1100;
        }
    }
`;